import React from 'react';
import Tooltip from 'Snippets/Tooltip';

export const IntroNotice = ({ message = 1 }) => (
	<div style={{ textAlign: 'center' }}>
		<Tooltip
			persistent
			placement='left-top'
			offset={[45]}
			message={
				message === 2 ? (
					<>
						Yow, if you haven't check the help in <b>Getting Started</b> yet.
						You will lost in this one.
					</>
				) : (
					<>
						Hi, if you haven't check the guide in <b>Advance Design Pattern</b>{' '}
						yet. You will lost in this one.
					</>
				)
			}
			style={{ zIndex: 1000000 }}>
			<img
				src='/images/icons/icon-72x72.png'
				alt='beard guy'
				width='60px'
				height='60px'
				style={{ display: 'inline-block' }}
			/>
		</Tooltip>
	</div>
);
